import React, { useState, useEffect } from 'react'
import './Timeline.css'
import { useTranslation } from 'react-i18next'
import { RiFileCopy2Line } from 'react-icons/ri'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { Link } from 'components/common'
import { useContext } from 'react'
import { TubularContext } from 'stores/TubularStore'

const AuditCard = ({ data }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const [selectDetail, setSelectDetail] = useState('')
    const { setValueData } = useContext(TubularContext)
    
    useEffect(() => {
        if (selectDetail === 'sot') {
            setValueData(data.detail['Service Order'])
            history.push("/sot/" + data.detail['Service Order'])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectDetail, history])

    const toGo = (value) => {
        setSelectDetail(value)
    }
    const content =
        <div className="timeline-item-content">
            <span className="title">
                <RiFileCopy2Line className="icon" />
                {t('tlh.ippn.audit.title')}
            </span>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.audit.result')}: </span>
                    <span className="value">{data.detail['Audit Result']}</span>
                </div>
            </section>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.audit.serviceOrder')}: </span>
                    <span className="value">
                        <Link onClick={() => toGo('sot')}>
                            {data.detail['Service Order']}
                        </Link>
                    </span>
                </div>
            </section>
            <span className="circle" > {moment(data.date).format('DD/MM/YYYY')} </span>
        </div>
    return content
}

export default AuditCard